import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ButtonsComponent} from './buttons/buttons.component';
import {MDBBootstrapModulesPro} from 'ng-uikit-pro-standard';


import {LicenseManager} from 'ag-grid-enterprise';
import {SharedModule} from '../../shared/shared.module';
import {IconsComponent} from './icons/icons.component';
import {FormsComponentElements} from './forms/forms.component';
import {FormsModule} from '@angular/forms';
import {TablesComponent} from './tables/tables.component';
import {PaginationComponent} from './tables/pagination/pagination.component';
import {TableItemComponent} from './tables/table-item/table-item.component';
import {TableHeaderComponent} from './tables/table-header/table-header.component';
import {TheadComponent} from './tables/thead/thead.component';
import {TypeaheadComponent} from './tables/typeahead/typeahead.component';
import {PannelsComponent} from './pannels/pannels.component';
import {ModalComponent} from './pannels/modal/modal.component';
import {CollapseComponent} from './pannels/collapse/collapse.component';
import {ListComponent} from './list/list.component';
import {ListGroupComponent} from './list/list-group/list-group.component';
import {QuickeditComponent} from './pannels/quickedit/quickedit.component';
import {RevealComponent} from './pannels/reveal/reveal.component';
import {FancyloaderComponent} from './tables/fancyloader/fancyloader.component';
import {NavigationComponent} from './navigation/navigation.component';
import {RouterModule} from "@angular/router";
import {SelectColumnComponent} from './tables/select-column/select-column.component';
import {SelectItemsComponent} from './tables/select-column/select-items/select-items.component';
import {FilterShelfComponent} from './pannels/filter-shelf/filter-shelf.component';
import {FilterItemComponent} from './pannels/filter-item/filter-item.component';
import {ManageItemsModalComponent} from './manage-items-modal/manage-items-modal.component';
import {AddItemsComponent} from './add-items/add-items.component';
import {StudentSelectComponent} from './student-select/student-select.component';
import {TypeFilterComponent} from './tables/typeahead/type-filter/type-filter.component';
import {ExpandComponent} from './pannels/expand/expand.component';
import {DataCirclesComponent} from './data/data-circles/data-circles.component';
import {ResponsiveModule} from 'ngx-responsive';
import {HamburgerMenuComponent} from './hamburger-menu/hamburger-menu.component';
import {TourComponent} from './tour/tour.component';
import {HelpersComponent} from './helpers/helpers.component';
import {InputCounterComponent} from './helpers/input-counter/input-counter.component';
import {ProgressComponent} from './navigation/progress/progress.component';
import {UserIconComponent} from './pannels/user-icon/user-icon.component';
import {ContextMenuComponent} from './buttons/context-menu/context-menu.component';
import {TabsComponent} from './navigation/tabs/tabs.component'
import {TagListComponent} from './list/tag-list/tag-list.component'
import {DashboardComponent} from './dashboard/dashboard.component';
import {DataListComponent} from './data/data-list/data-list.component';
import {DataCardComponent} from './data/data-card/data-card.component'
import {CreatePanelComponent} from "./pannels/create-panel/create-panel.component";
import {ScheduleNotificationsComponent} from "./schedule-notifications/schedule-notifications.component";
import { AvatarComponent } from './student-select/avatar/avatar.component';
import { PresetsComponent } from './presets/presets.component';
import { SelectListComponent } from './list/select-list/select-list.component';
import { FeedbackComponent } from './feedback/feedback.component';

// LicenseManager.setLicenseKey('Allantra_Learning_Technologies_Corp._AVANTI_E-training_System_single_2_Devs_1_Deployment_License_30_July_2020_[v2]_MTU5NjA2NzIwMDAwMA==92de89e5de12c12b0e0009b5f054e218');

@NgModule({

  imports: [
    CommonModule, SharedModule, MDBBootstrapModulesPro.forRoot(), FormsModule, RouterModule,
    ResponsiveModule.forRoot(),
  ],
  declarations: [ButtonsComponent, IconsComponent, FormsComponentElements,
    TablesComponent, PaginationComponent, TableItemComponent,
    TableHeaderComponent, TheadComponent, TypeaheadComponent,
    PannelsComponent, ModalComponent, CollapseComponent, ListComponent,
    ListGroupComponent, QuickeditComponent, RevealComponent, FancyloaderComponent,
    NavigationComponent, SelectColumnComponent, SelectItemsComponent, FilterShelfComponent,
    FilterItemComponent, ManageItemsModalComponent, AddItemsComponent, StudentSelectComponent,
    TypeFilterComponent, ExpandComponent, DataCirclesComponent, HamburgerMenuComponent, TourComponent,
    HelpersComponent, InputCounterComponent, ProgressComponent, UserIconComponent, ContextMenuComponent, TagListComponent,
    DataListComponent, DataCardComponent, CreatePanelComponent, TabsComponent, ScheduleNotificationsComponent, AvatarComponent, PresetsComponent, SelectListComponent, FeedbackComponent],
  exports: [ResponsiveModule, ButtonsComponent, IconsComponent, FormsComponentElements,
    TablesComponent, PaginationComponent, TableItemComponent, TableHeaderComponent,
    TheadComponent, TypeaheadComponent, PannelsComponent, ModalComponent, CollapseComponent,
    ListComponent, ListGroupComponent, QuickeditComponent, RevealComponent, FancyloaderComponent,
    NavigationComponent, SelectColumnComponent, SelectItemsComponent, FilterShelfComponent,
    FilterItemComponent, ManageItemsModalComponent, AddItemsComponent, StudentSelectComponent,
    TypeFilterComponent, ExpandComponent, DataCirclesComponent, HamburgerMenuComponent, TourComponent,
    HelpersComponent, InputCounterComponent, ProgressComponent, UserIconComponent, ContextMenuComponent,
    TagListComponent, DataListComponent, DataCardComponent, CreatePanelComponent, TabsComponent,ScheduleNotificationsComponent, AvatarComponent, PresetsComponent, SelectListComponent, FeedbackComponent]

  // declarations: [ButtonsComponent],
  // imports: [
  //   CommonModule
  // ]
})
export class ElementsModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ElementsModule
    }
  }
}



